module.exports = __webpack_public_path__ + "./images/icomoon.cd70d4.svg";